let _cache = null;

export async function loadGarmentMetrics() {
  if (_cache) return _cache;
  const ASSET_BASE =
  process.env.REACT_APP_ASSET_BASE_URL ||
  "https://pub-f0f38b8dd0224e2f89367893cf6bb0d7.r2.dev";

const res = await fetch(`${ASSET_BASE}/garments/garmentMetrics.json`);
  if (!res.ok) throw new Error(`Failed to load garmentMetrics.json: ${res.status}`);
  _cache = await res.json();
  return _cache;
}

export function garmentKeyFromUrl(glbUrlOrPath) {
  // supports "models/garments/top_fitted.glb" or "/models/garments/top_fitted.glb"
  const file = glbUrlOrPath.split("/").pop() || "";
  return file.replace(/\.glb$/i, "");
}
